import React from 'react';
import PropTypes from 'prop-types';
import { dollar } from '../util';

function RegistryTransaction({
  name = 'Anonymous',
  amount = 0,
  date = { seconds: 0 },
  contribution = false
}) {
  const purchase = contribution ? dollar.format(amount) : amount;
  return (
    <li>
      {name} contributed {purchase} on{' '}
      {new Date(date.seconds * 1000).toLocaleDateString()}
    </li>
  );
}

RegistryTransaction.propTypes = {
  name: PropTypes.string,
  amount: PropTypes.number,
  date: PropTypes.object,
  contribution: PropTypes.bool
};

export default RegistryTransaction;
